import React from 'react';
import { Link, } from 'react-router';
import { format } from 'date-fns';
import Header from './Layout/Header';
import { maskEventRemarks, isMigratedEventRemarks, maskLocationName } from '../utils/utils'
import '../../public/css/media/_track-details.scss';

const createReactClass = require('create-react-class');
const TrackDetail = createReactClass({
  componentWillMount() {
    document.title = "Tracking Details";
  },
  componentWillReceiveProps(nextProps) {
    if(nextProps.shipmentInfo.fetched_order) {
      const { status } = nextProps.shipmentInfo.order.data;

      switch (status) {
        case "confirmed":
        case "for_pickup":
        case "consolidated":
        case "for_consolidation":
          this.setState({ orderStatus: { class: 'prepshipment', imagePath: 'shipment2' }});
          break;
        case "failed_pickup":
        case "in_transit":
        case "out_for_delivery":
        case "failed_delivery":
        case "return_in_transit":
        case "returned":
        case "failed_return":
        case "for_acceptance":
        case "accepted":
        case "received_at_pickup_hub":
        case "received_at_delivery_hub":
        case "for_return":
        case "received_at_delivery_area":
        case "at_sorting_center":
        case "in_transit_to_delivery_area":
        case "transferred_to_partner":
        case "for_transfer":
        case "out_for_return":
        case "for_dropoff":
        case "dropped_off":
        case "dws_update":
          this.setState({ orderStatus: { class: 'intransit', imagePath: 'shipment1', size: '130%' }});
          break;
        case "delivered":
        case "claimed":
        case "picked_up":
          this.setState({ orderStatus: { class: 'delivered', imagePath: 'shipment3', size: '135%' }});
          break;
        default:
        this.setState({ orderStatus: { class: status }});
      }
    }
  },
  componentDidMount() {
    window.scrollTo(0, 0);
    const token = localStorage.jwtToken;
    this.props.getOrderDetails(this.props.params.id, token);
  },
  componentWillUnmount() {
    this.props.resetOrders();
  },
  handleStatuses(shipment_status, type, payment_status) {
    var str = shipment_status === "canceled" && payment_status === "rejected" ? payment_status :  shipment_status;

    if (str) {
      if (type === "class") {
        switch (str) {
          case "confirmed":
          case "for_pickup":
          case "consolidated":
          case "for_consolidation":
            return "paid";
          case "failed_pickup":
          case "in_transit":
          case "out_for_delivery":
          case "failed_delivery":
          case "return_in_transit":
          case "returned":
          case "failed_return":
          case "for_acceptance":
          case "accepted":
          case "received_at_pickup_hub":
          case "received_at_delivery_hub":
          case "for_return":
          case "received_at_delivery_area":
          case "at_sorting_center":
          case "in_transit_to_delivery_area":
          case "transferred_to_partner":
          case "for_transfer":
          case "out_for_return":
          case "for_dropoff":
          case "dropped_off":
          case "dws_update":
            return "transit";
          case "canceled":
          case "rejected":
            return "cancelled"
          case "delivered":
          case "claimed":
          case "picked_up":
            return "delivered";
          default:
            return str.replace("_", "-");
        }
      } else if (type === "text") {
        switch (str) {
          case "confirmed":
          case "for_pickup":
          case "consolidated":
          case "for_consolidation":
            return "PREPARING FOR SHIPMENT";
          case "failed_pickup":
          case "in_transit":
          case "out_for_delivery":
          case "failed_delivery":
          case "return_in_transit":
          case "returned":
          case "failed_return":
          case "for_acceptance":
          case "accepted":
          case "received_at_pickup_hub":
          case "received_at_delivery_hub":
          case "for_return":
          case "received_at_delivery_area":
          case "at_sorting_center":
          case "in_transit_to_delivery_area":
          case "transferred_to_partner":
          case "for_transfer":
          case "out_for_return":
          case "for_dropoff":
          case "dropped_off":
          case "dws_update":
            return "ON ITS WAY";
          case "canceled":
            return "CANCELLED"
          case "delivered":
          case "claimed":
          case "picked_up":
            return "DELIVERED";
          default:
            return str.replace("_", " ").toUpperCase();
        }
      }
    }
    return str;
  },
  render() {
    return (
      <div>
        <Header
          isAuthenticated={true}
          login={this.props.login}
          logout={this.props.logout}
        />
        <div className="body-wrapper">
          <div className="view-shipping">
            <div className="container padding-top-20">
              <div className="clearfix">
                <h1 className="pull-left">Shipment Details</h1>
                <Link to="/track-package" className="pull-right back-link u">&#60; Back</Link>
              </div>

              {
                this.props.shipmentInfo.fetched_order &&
                  <div className={`shipmentdetails ${this.state.orderStatus.class}`}>
                    <div className="statusbox" />
                    <hr />

                    <div className="clearfix">
                      <div className="pull-left imgbox">
                        <span><img style={{'max-width':this.state.orderStatus.size}} src={`/img/${this.state.orderStatus.imagePath}.png`} alt="" /></span>
                      </div>
                      <div className="pull-right contentbox">
                        {this.props.shipmentInfo.order.data.shipment.includes("air") ?
                          <span className="aircargo cargotype">Air Cargo</span> : <span className="seacargo cargotype">Sea Cargo</span>}

                        <div className="clearfix">
                          <div className="col-xs-4">
                            <h2>Transaction Date:</h2>
                            <p>{ format(this.props.shipmentInfo.order.data.tat.pending ? this.props.shipmentInfo.order.data.tat.pending.date : this.props.shipmentInfo.order.data.created_at, 'MM/DD/YYYY') }</p>
                            <h2>Tracking #:</h2>
                            <p>{this.props.shipmentInfo.order.data.tracking_number}</p>

                            <h3>Item/s:</h3>
                            { this.props.shipmentInfo.order.data.items.filter(item => item.type === 'product').map((item, i) => <p key={i}>{item.description}</p>) }
                          </div>
                          <div className="col-xs-4">
                            <h2>From:</h2>
                            <p>{maskLocationName(this.props.shipmentInfo.order.data.pickup_address.country.code)} Warehouse</p>
                            <h2>Ship to:</h2>
                            <p>{this.props.shipmentInfo.order.data.delivery_address.name}, {this.props.shipmentInfo.order.data.delivery_address.line_1}, {this.props.shipmentInfo.order.data.delivery_address.district}, {this.props.shipmentInfo.order.data.delivery_address.city}, {this.props.shipmentInfo.order.data.delivery_address.state}, {this.props.shipmentInfo.order.data.delivery_address.country.name} </p>
                          </div>
                          <div className="col-xs-4">
                            { this.state.orderStatus.class !== 'delivered' &&
                              <div>
                                <h2>Estimated Delivery Date:</h2>
                                <p>{format(this.props.shipmentInfo.order.data.shipment.includes("air") ? this.props.shipmentInfo.order.data.metadata.delivery_tat.air : this.props.shipmentInfo.order.data.metadata.delivery_tat.sea,'MM/DD/YYYY')}</p>
                              </div>
                            }

                            <h2>Latest Update:</h2>
                            {
                              this.props.shipmentInfo.order.data.events.map((ev, i, arr) =>
                                i === this.props.shipmentInfo.order.data.events.length - 1 &&
                                (<div key={i}>
                                    <p>{format(isMigratedEventRemarks(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')}</p>
                                    <p>{ev.status === 'for_acceptance' || (this.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks.toLowerCase().includes("accepted at office")) ? maskEventRemarks(arr[i -1].remarks) : maskEventRemarks(ev.remarks, ev.status_updated_at, ev.status)}</p>
                                  </div>)
                              )
                            }
                            <a className="modalanchor" data-toggle="modal" data-target="#shiphistory">View Shipping Details</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              }

              {/*Shipment History Modal*/}
              <div id="shiphistory" className="modal" style={{'zIndex': '99999'}}>
                <div className="modal-dialog">
                  <div className="modal-content">
                    <header className="modal-header">
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <div className="clearfix">
                        {
                          this.props.shipmentInfo.fetched_order &&
                            <div className="pull-left currentactivity">
                              <h2>Current Activity:</h2>
                              <p>{ this.props.shipmentInfo.order.data.events.map((ev, i, arr) =>
                                i === this.props.shipmentInfo.order.data.events.length - 1 ?
                                 ev.status === 'for_acceptance' || (this.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks.toLowerCase().includes("accepted at office")) ? maskEventRemarks(arr[i -1].remarks) :
                                 maskEventRemarks(ev.remarks, ev.status_updated_at, ev.status) : null)
                                }
                              </p>
                            </div>
                        }
                        <div className="pull-right text-center padding-top-20">
                          <label className={this.handleStatuses(this.props.shipmentInfo.fetched_order && this.props.shipmentInfo.order.data.status, "class")}>{this.handleStatuses(this.props.shipmentInfo.fetched_order && this.props.shipmentInfo.order.data.status, "text")}</label>
                          <p>Tracking #: {this.props.shipmentInfo.fetched_order && this.props.shipmentInfo.order.data.tracking_number}</p>
                        </div>
                      </div>
                    </header>
                    <div className="modal-body padding-3percent">
                      <h3>Shipping History: </h3>
                      <table>
                        <thead>
                          <tr>
                            <th>Date/Time</th>
                            <th>Activity</th>
                          </tr>
                        </thead>
                        {this.props.shipmentInfo.fetched_order &&
                          <tbody>
                            {this.props.shipmentInfo.order.data.events.slice(0).reverse().map((ev, i) =>
                              ev.status === "consolidated" || ev.status === 'for_acceptance' || (this.props.shipmentInfo.order.data.shipment === 'uk-sea' && ev.remarks.toLowerCase().includes("accepted at office")) ? null
                              : <tr key={i}>
                                <td>{format(isMigratedEventRemarks(ev.created_at) ? ev.status_updated_at : ev.created_at, 'MM/DD/YYYY HH:mm:ss')}</td>
                                <td>{maskEventRemarks(ev.remarks, ev.status_updated_at, ev.status)}</td>
                              </tr>
                            )}
                          </tbody>
                        }
                      </table>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  },
});

export default TrackDetail;



/** WEBPACK FOOTER **
 ** ./src/components/TrackDetail.js
 **/